import React from 'react';

const PageLoader: React.FC = () => {
  return (
    <div className="min-h-[60vh] flex items-center justify-center">
      <div className="loading-spinner h-10 w-10" />
    </div>
  );
};

export default PageLoader;
